import { jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { observerRPC } from "../core/observerRPC.js";
import { RPCInstanceContext } from "./fields.js";
const RPCProvider = ({ children })=>{
    const observer = useRef(observerRPC());
    const mount = useCallback((item, name)=>{
        const { add, remove } = observer.current;
        if (!('getType' in item)) return;
        if (void 0 === name) remove(item);
        else add(item, name);
    }, []);
    useEffect(()=>{
        const ins = observer.current;
        return ()=>{
            ins.clear();
        };
    }, []);
    return /*#__PURE__*/ jsx(RPCInstanceContext.Provider, {
        value: {
            brodcastScope: observer.current.brodcastScope,
            mount
        },
        children: children
    });
};
const react_RPCProvider = RPCProvider;
export { react_RPCProvider as default };
